export default __webpack_public_path__ + "static/media/compass.c79c59d4.png";